import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from '@/api';
import {
    PaginatedResponse,
    Rate,
    ServiceMapping
} from '@/interfaces';

@Injectable({
    providedIn: 'root'
})
export class ServiceMappingsService {

    constructor(private apiService: ApiService) {
    }

    listing(params: Record<string, any>): Observable<PaginatedResponse<Rate>> {
        return this.apiService.get<any>('/service-mappings', this.apiService.build(params)).pipe(
            map((res: any) => ({
                data: res.data,
                total: res.total,
                current_page: res.current_page,
                per_page: res.per_page
            }))
        );
    }

    edit(id: string, data: Record<string, any>): Observable<ServiceMapping> {
        return this.apiService.patch<ServiceMapping>(`/service-mappings/${id}`, data)
            .pipe(map(response => response.data));
    }

    export(params: Record<string, any>): Observable<Blob> {
        return this.apiService.postBlob('/service-mappings/export', params);
    }

    autocomplete(field: 'service' | 'service_mapped', query: string, context: Record<string, any> = {}) {
        return this.apiService.get<string[]>(
            `/service-mappings/autocomplete/${field}`,
            this.apiService.build({ q: query, ...context })
        );
    }
}
